import React from "react";
import { Award } from "lucide-react";
import AwardCardCompact from "./AwardCardCompact";
import HeaderComponent from "components/card/HeaderComponent";

const HyvidAwardWinners = () => {


    return (
        <HeaderComponent
            title="Hyvid Awards Winners"
            description="Celebrating excellence and exceptional achievements"
            icon={<Award className="w-5 h-5 text-white"/>}
            colorTheme="bg-gradient-to-br from-amber-400 to-orange-500" 
            bgcolor="bg-slate-50 dark:bg-slate-900"                                      
        >
            <div className="pt-6">
                    <AwardCardCompact/>
            </div>
        </HeaderComponent>

    )
};
export default HyvidAwardWinners;